import { useMemo, useState } from "react";
import { ColDef } from "ag-grid-community";
import { Invoice } from "./Data/ApiTypes";
import { useLoaderData, useNavigate } from "react-router-dom";
import { showMoney, cents, Money } from "./Data/Money";
import { BalanceStatusRenderer, DataGrid } from "./Controls/DataGrid";
import { showDate, showInstantDate } from "./Data/Date";
import { PageBar, ToolButton } from "./Controls/PageBar";
import { gridOneCol } from "./Data/Common";
import { Col, Container, Row } from "react-bootstrap";
import { add, equal } from "dinero.js";
import { Plus } from "react-bootstrap-icons";
import { FacilityInvoiceCreatePage } from "./FacilityCustomOrderCreatePage";

export function FacilityParkerInvoiceListPage() {
    const [showCustomOrder, setShowCustomOrder] = useState(false);
    const nav      = useNavigate();
    const invoices = useLoaderData() as Invoice[];
    const addMoney = (a: Money, b: Money) => add(a, b);
    const getTotalBalance = (invoice: Invoice) => invoice.orders.reduce<Money>((sum, order) => addMoney(sum, order.balance.balance), cents(0));
    const parker = invoices.find(x => x.parker);

    const columns = useMemo<ColDef<Invoice>[]>( () => [
        { field: "invoiceNumber",          headerName: "Invoice #", type: "rightAligned" },
        { field: "createdWhen",            headerName: "Created", valueFormatter: x => showInstantDate(x.value, x.data?.facility.timeZone ?? "UTC") },
        { 
            headerName: "Summary",
            valueGetter: params => params.data?.orders?.map(o => o.summary).join(", ") ?? ""
        },
        { field: "amountDue",          headerName: "Price", type: "rightAligned", valueFormatter: p => showMoney( p.value ) },
        // { ...colMoney( "openingBalance" ), headerName: "Starting Balance" },
        { field: "endingBalance",          headerName: "Balance", type: "rightAligned", valueFormatter: p => showMoney( p.value ) },
        { field: "dueWhen",                headerName: "Due Date", valueFormatter: x => showDate( x.value ) },
        {
        field: "amountDue",
        headerName: "Status",
        valueGetter: params => params.data ? getTotalBalance(params.data) : cents(0),
        cellRenderer: BalanceStatusRenderer,
        getQuickFilterText: params => equal(getTotalBalance(params.data), cents(0)) ? "Paid" : "Unpaid",
        filterValueGetter: params => equal(getTotalBalance(params.data!), cents(0)) ? "Paid" : "Unpaid",
        filter: "agTextColumnFilter"
        }
    ], [] );

    const onRowClicked = ( event: any ) => {
        const invoice: Invoice = event.data;
        const facilityId = invoice.facility.facilityId;
        const parkerId = invoice.parker.parkerId;
        const invoiceId = invoice.invoiceId;
        nav(`/facility/${facilityId}/parker/${parkerId}/invoice/${invoiceId}`);
    };
return (
  <Container fluid className="h-100">
    <Row className="h-100">
      <Col style={gridOneCol("max-content 1fr 5px")}>
        {!showCustomOrder && (
        <div className="d-flex align-items-center gap-2 mb-3">
            <PageBar title="Invoices" />
            <ToolButton onClick={() => setShowCustomOrder(true)}>
                <Plus color="maroon" /> Custom Order
            </ToolButton>
           </div>

        )}

        {showCustomOrder ? (
          <FacilityInvoiceCreatePage
            recipientOverride={{
              name: parker!.parker.name,
              emailAddress: parker!.parker.emailAddress,
              phoneNumber: parker!.parker.phoneNumber,
            }}
            setShowCustomOrder={setShowCustomOrder}
          />
        ) : (
          <DataGrid
            rowData={invoices}
            columnDefs={columns}
            onRowClicked={onRowClicked}
          />
        )}
      </Col>
    </Row>
  </Container>
)
}
